import { EMPTY, typeOf, type Move } from '../game/types.js';
import { PIECE_VALUES } from './pst.js';

const PV_SCORE = 1_000_000;
const CAPTURE_BASE = 100_000;
const PROMOTION_BASE = 90_000;
const KILLER_SCORE = 80_000;
const MVV_WEIGHT = 10;

export function sameMove(a: Move, b: Move): boolean {
  return a.from === b.from && a.to === b.to && a.promotion === b.promotion;
}

function score(move: Move, pv: Move | null, killers: readonly Move[]): number {
  if (pv !== null && sameMove(move, pv)) return PV_SCORE;
  let s = 0;
  if (move.captured !== EMPTY) {
    // Most valuable victim, least valuable attacker.
    s += CAPTURE_BASE + (PIECE_VALUES[typeOf(move.captured)] ?? 0) * MVV_WEIGHT - (PIECE_VALUES[typeOf(move.piece)] ?? 0);
  }
  if (move.promotion !== EMPTY) s += PROMOTION_BASE + (PIECE_VALUES[move.promotion] ?? 0);
  if (s === 0 && killers.some((k) => sameMove(k, move))) s = KILLER_SCORE;
  return s;
}

/** Best-first ordering: PV move, captures (MVV-LVA), promotions, killers, quiet moves. */
export function orderMoves(moves: readonly Move[], pv: Move | null = null, killers: readonly Move[] = []): Move[] {
  return moves
    .map((m) => ({ m, s: score(m, pv, killers) }))
    .sort((a, b) => b.s - a.s)
    .map((x) => x.m);
}
